<!--
 * @Author: your name
 * @Date: 2020-06-22 10:51:45
 * @LastEditTime: 2020-09-25 11:34:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dudao\src\components\HelloWorld.vue
--> 
<template>
<div class="hello">
    <div class="top">
        <el-carousel ref="carousel" arrow="always" height="8.8rem" class="pc" :autoplay="false" loop @change="change">
            <el-carousel-item v-for="(item,index) in banner" :key="index">
                <video :id="'video'+index" v-if="item.video" :autoplay="true" muted loop :src="item.video" />
                <img v-else :src="item.img" alt style="cursor:pointer" @click="open(item)" />
            </el-carousel-item>
        </el-carousel>
        <div class="mobile">
            <swiper ref="swiper1" :options="option1" class="swiper">
                <swiper-slide v-for="(item,index) in banner" :key="index">
                    <!-- <el-image  :src="item.img" fit="fit"></el-image> -->
                    <video v-if="item.video" :autoplay="index ==0" :src="item.video" style="width: 100%; height: 200px" />
                    <img v-else :src="item.img" style="width: 100%; height: 200px" @click="open(item)" />
                </swiper-slide>
            </swiper>
        </div>
    </div>
    <div class="main">
        <div class="featured">
            <h1 class="cn">精選珠寶</h1>
            <p class="en">Featured jewelry</p>
            <div class="box">
                <el-image :src=" recommend.data[0].img[0]" fit="cover"></el-image>
                <div class="inner">
                    <p class="title text-overflow pc">
                        <span class="serise">{{recommend.data[0].category_name}}</span>
                        {{recommend.data[0].title}}
                    </p>
                    <p class="title text-overflow-more text-overflow-more-2 mobile">
                        <span class="serise">{{recommend.data[0].category_name}}</span>
                        {{recommend.data[0].title}}
                    </p>
                    <p class="no">{{recommend.data[0].code}}</p>
                    <p class="content text-overflow-more-4 text-overflow-more">{{recommend.data[0].intro}}</p>
                    <span @click="$router.push({path:'/'+recommend.data[0].url+'/detail',query:{id:recommend.data[0].id}})">查看詳細介紹</span>
                </div>
            </div>
        </div>
        <div class="swiper-w">
            <!--  <div class="left"></div>
        <div class="right"></div>-->
            <swiper ref="swiper" v-if="recommend.data.length" :options="option" class="swiper pc">
                <swiper-slide v-for="(item,index) in recommend.data" :key="index" @click.native="to(item)">
                    <!-- <el-image :src="item.img" fit="fit"></el-image> -->
                    <img :src="item.img[0]" class="el-image" style="object-fit:cover" />
                    <p class="text-overflow name">{{item.title}}</p>
                    <p class="desc text-overflow-more-2 text-overflow-more">{{item.intro}}</p>
                </swiper-slide>
            </swiper>
        </div>
        <swiper ref="swipermobile" v-if="recommend.data.length" :options="option2" class="swiper mobile">
            <swiper-slide v-for="(item,index) in recommend.data" :key="index" @click.native="to(item)">
                <el-image :src="item.img[0]" fit="fit"></el-image>
                <p class="text-overflow-more-2 text-overflow-more name">{{item.title}}</p>
                <p class="desc text-overflow-more-2 text-overflow-more">{{item.intro}}</p>
            </swiper-slide>
        </swiper>
        <div class="dot pc">
            <i class="el-icon-arrow-left" @click="prev"></i>
            <span v-for="(item,index) in recommend.data" :key="index" :class="{active:active == index}"></span>
            <i class="el-icon-arrow-right" @click="next"></i>
        </div>
    </div>
    <div class="address">
        <div>
            <p>店鋪地址</p>
            <div>
                <p>
                    <img src="../assets/img/address.png" alt srcset />
                    地址：{{shop.address}}
                </p>
                <p>
                    <img src="../assets/img/phone.png" alt srcset />
                    Tel：{{shop.custom_tel}}
                </p>
                <p>
                    <img src="../assets/img/email.png" alt srcset />
                    邮箱：{{shop.email}}
                </p>
                <div class="btn" @click="toshop('tianmao_url')">
                    <i class="el-icon-caret-right"></i>
                    <img src="../assets/img/Tmall.png" alt />
                    進入天貓店鋪
                </div>
            </div>
        </div>
        <div>
            <p>關注我們</p>
            <div>
                <div class="internet">
                    <img src="../assets/img/sina.png" alt v-show="contact_active !== 0" @click="contact_active=0" />
                    <img src="../assets/img/sina1.png" alt v-show="contact_active == 0" />
                    <img src="../assets/img/taobao.png" alt v-show="contact_active !== 1" @click="contact_active=1" />
                    <img src="../assets/img/taobao1.png" alt v-show="contact_active == 1" />
                    <img src="../assets/img/weixin1.png" alt v-show="contact_active == 2" style="margin:0" />
                    <img src="../assets/img/weixin.png" alt v-show="contact_active !== 2" @click="contact_active=2" />
                </div>
                <div class="qr">
                    <div v-show="contact_active == 0">
                        <p>微博二维码</p>
                        <img :src="shop.weibo" alt srcset />
                    </div>
                    <div v-show="contact_active == 1">
                        <p>淘宝二维码</p>
                        <img :src="shop.taobao" alt srcset />
                    </div>
                    <div v-show="contact_active == 2">
                        <p>微信公衆號</p>
                        <img :src="shop.wechat" alt srcset />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="history pc" @click="$router.push({path:'/customized'})"></div>
    <img src="../assets/img/history-bg.png" class="mobile" alt @click="$router.push({path:'/customized'})" />
    <div class="active">
        <h1>最新活動</h1>
        <p class="en">latest events</p>
        <div class="activity">
            <router-link :to="{path:'ency-detail',query:{id:item.id}}" tag="div" v-for="(item,index) in news" :key="index">
                <el-image style="width: 5.1rem; height: 3.38rem" :src="item.img" fit="fit"></el-image>
                <p class="time">{{item.create_time}}</p>
                <p class="title text-overflow-more text-overflow-more-2">{{item.title}}</p>
                <p class="desc text-overflow-more text-overflow-more-2">{{item.intro}}</p>
            </router-link>
        </div>
        <div class="btn" @click="$router.push({path:'/encyclopedias',query:{type:1}})">
            查看更多
            <i class="el-icon-right"></i>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "HelloWorld",
    data() {
        let _this = this;
        return {
            video_active: 0,
            recommend: [],
            banner: [],
            active: 0,
            shop: {},
            contact_active: 0,
            news: [],
            option1: {
                autoplay: true,
                loop: true,
            },
            option2: {
                slidesPerView: 2,
                spaceBetween: 10,
                autoplay: true,
            },
            option: {
                slidesPerView: 4,
                autoplay: true,
                spaceBetween: 80,
                loop: true,
                on: {
                    transitionEnd: function () {
                        _this.active = this.realIndex;
                    },
                },
            },
        };
    },
    mounted() {
        this.axios
            .post("banner/index", {
                nav_id: 1,
            })
            .then((r) => {
                this.banner = [...r];
            });
        this.axios
            .post("product/top_lists", {
                page: 1,
                per_page: 4,
            })
            .then((r) => {
                this.recommend = r;
            });
        this.axios.get("config/info").then((r) => {
            this.shop = {
                ...r,
            };
            localStorage.setItem("shop", JSON.stringify(r));
            console.log(this.$parent);
            this.$parent.shop = {
                ...r,
            };
        });
        this.axios
            .post("news/index", {
                type: 2,
                per_page: 2,
            })
            .then((r) => {
                this.news = r.data;
                this.news.forEach((val) => {
                    if (val.create_time.length == 13) {
                        val.create_time = val.create_time / 1000;
                    }
                    val.create_time = this.formatteTime(val.create_time);
                });
            });
    },
    methods: {
        change(e) {
            if (this.banner[e].video) {
                console.log(this.$refs.carousel);
            }
        },
        open(e) {
            window.open(e.link_url);
        },
        toshop(e) {
            window.open(this.shop[e]);
        },
        prev() {
            let swiper = this.$refs.swiper;
            swiper.swiper.slidePrev();
            console.log(swiper);
        },
        to(e) {
            this.$router.push({
                path: `/${e.url}/detail`,
                query: {
                    id: e.id,
                },
            });
        },
        next() {
            let n =
                this.active == this.recommend.data.length - 1 ? 0 : this.active + 1;
            let swiper = this.$refs.swiper;
            swiper.swiper.slideTo(n, 300);
            console.log(swiper);
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
.swiper-w {
    position: relative;

    &>.left,
    &>.right {
        width: 20%;
        height: 100%;
        position: absolute;
        top: 0;
        background: rgba(255, 255, 255, 0.5);
        z-index: 999;
    }

    &>.left {
        left: 0;
    }

    &>.right {
        right: 0;
    }
}

.top {
    width: 100%;
    height: 8.8rem;
    background: #f7f7f7;
    padding: 0.2rem;
    box-sizing: border-box;

    .el-carousel {

        img,
        video {
            width: 16.5rem;
            height: 8.4rem;
            object-fit: cover;
            margin: 0 auto;
            display: block;
        }
    }
}

.main {
    padding: 1.01rem 0;

    .featured {
        padding: 0 3.6rem;
        box-sizing: border-box;

        .box {
            font-size: 0;
            margin-top: 0.42rem;

            *>div {
                display: inline-block;
            }

            .el-image {
                width: 6.3rem;
                height: 6.3rem;
            }

            .inner {
                background: #f7f7f7;
                width: calc(100% - 6.3rem);
                display: inline-block;
                height: 6.3rem;
                padding: 0 0.8rem;
                box-sizing: border-box;
                vertical-align: text-bottom;
                padding-top: 1.43rem;

                .title {
                    font-size: 0.2rem;
                    font-family: "FZShuSong-Z01T";
                    font-weight: 400;
                    color: rgba(0, 0, 0, 1);

                    .serise {
                        color: rgba(127, 109, 70, 1);
                        display: inline-block;
                        padding: 0.09rem 0.1rem;
                        border: 1px solid rgba(127, 109, 70, 1);
                        margin-right: 0.1rem;
                    }
                }

                .no {
                    font-size: 0.16rem;
                    font-family: "Baskerville Old Face";
                    font-weight: 400;
                    color: rgba(0, 0, 0, 1);
                    margin-top: 0.16rem;
                    margin-bottom: 0.27rem;
                }

                .content {
                    font-size: 0.14rem;
                    // font-family: "FZShuSong-Z01T";
                    font-weight: 400;
                    color: rgba(0, 0, 0, 1);
                    text-transform: capitalize;
                    margin-bottom: 0.7rem;
                    line-height: 0.4rem;
                }

                &>span {
                    font-size: 0.14rem;
                    font-family: "FZShuSong-Z01T";
                    font-weight: 400;
                    color: rgba(0, 0, 0, 1);
                    border-bottom: 1px solid #000000;
                    line-height: 15px;
                    cursor: pointer;
                }
            }
        }
    }

    .swiper {
        margin-top: 1rem;

        .el-image {
            width: 100%;
            height: 2.3rem;
            margin-bottom: 0.33rem;
            cursor: pointer;
        }

        .name {
            font-size: 0.16rem;
            cursor: pointer;
            font-family: "FZShuSong-Z01T";
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            margin-bottom: 0.12rem;
        }

        .desc {
            cursor: pointer;
            font-size: 0.14rem;
            // font-family: "FZShuSong-Z01T";
            font-weight: 400;
            line-height: 24px;
        }
    }

    .dot {
        margin-top: 0.42rem;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
            width: 0.07rem;
            height: 0.07rem;
            background: rgba(0, 0, 0, 1);
            opacity: 0.2;
            margin-left: 0.13rem;
            transition: all 0.2s linear;
        }

        span.active {
            opacity: 1;
        }

        i {
            font-size: 0.2rem;
            cursor: pointer;
            font-weight: bolder;
            margin-right: 1.14rem;
        }

        i:last-child {
            margin-left: 1.14rem;
        }
    }
}

.address {
    background: #f7f7f7;
    display: flex;
    padding: 0.87rem 3.94rem;
    box-sizing: border-box;

    &>div {
        width: 50%;

        &>p {
            text-align: center;
        }

        &>div {
            width: 100%;
            padding-top: 0.62rem;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;

            &>p {
                font-size: 0.14rem;
                font-family: "FZShuSong-Z01T";
                font-weight: 400;
                color: rgba(0, 0, 0, 0.6);
                margin-bottom: 0.2rem;
                width: 100%;

                img {
                    width: 0.2rem;
                    height: 0.2rem;
                    vertical-align: sub;
                    margin-right: 0.052rem;
                }
            }

            .internet {
                padding: 0.1rem 0.2rem;
                border-bottom: 1px solid rgba(0, 0, 0, 0.2);

                img {
                    width: 0.3rem;
                    margin-right: 0.21rem;
                    cursor: pointer;
                }

                img:last-child {
                    margin-right: 0;
                }
            }

            .qr {
                display: flex;

                div:last-child {
                    margin-right: 0;
                }

                div {
                    p {
                        font-size: 0.16rem;
                        font-family: "FZShuSong-Z01T";
                        font-weight: 400;
                        color: rgba(0, 0, 0, 1);
                        margin: 0.2rem auto;
                        text-align: center;
                    }

                    img {
                        width: 1.05rem;
                        height: 1.05rem;
                    }
                }
            }

            .btn {
                width: 3.21rem;
                height: 0.65rem;
                display: flex;
                justify-content: center;
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(16, 16, 16, 1);
                margin: 0 auto;
                margin-top: 0.43rem;
                cursor: pointer;
                font-size: 0.16rem;
                font-family: "FZShuSong-Z01T";
                font-weight: 400;
                color: rgba(16, 16, 16, 1);
                align-items: center;
                padding: 0;
                position: relative;
                justify-content: center;

                i {
                    position: absolute;
                    left: 0.26rem;
                    top: 50%;
                    transform: translateY(-50%);
                }

                img {
                    width: 0.24rem;
                    height: 0.24rem;
                }
            }
        }
    }

    &>div:first-child {
        &>div {
            padding-right: 1.17rem;
            border-right: 1px solid rgba(0, 0, 0, 0.2);
        }
    }

    &>div:last-child {
        padding-left: 1rem;
    }
}

.history {
    height: 8.69rem;
    background: url("../assets/img/history-bg.png") no-repeat;
    background-size: cover;
    background-attachment: fixed;
    cursor: pointer;
}

div.active {
    margin-top: 1.2rem;

    .activity {
        margin-top: 0.8rem;
        display: flex;
        padding: 0 3.6rem;
        box-sizing: border-box;

        &>div {
            width: 50%;
            position: relative;
            font-weight: 400;
            cursor: pointer;

            .time {
                font-size: 0.12rem;
                color: rgba(33, 33, 33, 1);
                margin-top: 0.25rem;
                margin-bottom: 0.09rem;
            }

            .title {
                font-size: 0.16rem;
                margin-bottom: 0.22rem;
                font-family: "FZShuSong-Z01T";
            }

            .desc {
                font-size: 0.14rem;
                line-height: 24px;
            }
        }

        &>div:first-child {
            padding-right: 0.9rem;
        }

        &>div:first-child::after {
            content: " ";
            width: 1px;
            display: block;
            height: 2.7rem;
            background: rgba(0, 0, 0, 0.2);
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-70%);
        }

        &>div:last-child {
            padding-left: 0.9rem;
        }
    }

    .btn {
        width: 3.29rem;
        height: 0.59rem;
        border: 1px solid rgba(0, 0, 0, 1);
        cursor: pointer;
        margin: 0 auto;
        margin-top: 0.8rem;
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
        font-size: 0.16rem;
        font-family: "FZShuSong-Z01T";
        font-weight: 400;
        color: rgba(0, 0, 0, 1);

        i {
            position: absolute;
            right: 0.1rem;
            top: 50%;
            transform: translateY(-50%);
            font-size: 0.3rem;
        }
    }
}

@media (max-width: 767px) {
    .top {
        height: 200px;
        padding: 0;
    }

    h1 {
        font-size: 28px;
    }

    .en {
        font-size: 20px;
        margin-bottom: 30px;
    }

    .main {
        margin-top: 50px;

        .featured {
            padding: 0 10px;

            .box {

                .el-image,
                .inner {
                    height: auto;
                    width: 100%;
                }

                .inner {
                    display: block;
                    padding: 10px;

                    &>span {
                        font-size: 14px;
                    }

                    .no {
                        font-size: 14px;
                    }

                    .content {
                        margin-bottom: 20px;
                        font-size: 16px;
                        line-height: 20px;
                    }

                    .title {
                        font-size: 24px;

                        .serise {
                            font-size: 22px;
                        }
                    }
                }
            }
        }

        .mobile.swiper {
            &>* {
                cursor: pointer;
            }

            .el-image {
                height: 100px;
                cursor: pointer;
            }

            .name {
                font-size: 13px;
                margin-bottom: 10px;
                cursor: pointer;
            }

            .desc {
                font-size: 12px;
                cursor: pointer;
                color: rgb(101, 101, 101);
            }
        }
    }

    .address {
        padding: 10px;
        display: block;

        &>div {
            width: 100%;

            &>div {
                .internet {
                    width: 100%;
                    text-align: center;

                    img {
                        width: 40px;
                        margin-right: 15px;
                    }
                }

                .qr {
                    div {
                        p {
                            font-size: 14px;
                        }

                        img {
                            width: 150px;
                            height: 150px;
                            display: block;
                            margin: 10px auto;
                        }
                    }
                }

                &>p {
                    font-size: 14px;
                    margin-bottom: 10px;
                    line-height: 18px;

                    img {
                        width: 20px;
                        height: 20px;
                        margin-right: 10px;
                    }
                }

                .btn {
                    width: 80%;
                    height: 30px;
                    font-size: 16px;

                    img {
                        width: 20px;
                        height: 20px;
                    }

                    i {
                        font-size: 20px;
                    }
                }
            }
        }

        &>div:first-child {
            &>div {
                padding-right: 0;
                border-right: unset;
            }
        }

        &>div:last-child {
            padding-left: 0;
            margin-top: 20px;
        }
    }

    img.mobile {
        width: 100%;
    }

    div.active {
        .btn {
            width: 50%;
            height: 30px;
            font-size: 15px;

            i {
                font-size: 20px;
            }
        }

        .activity {
            padding: 0 10px;

            &>div:first-child::after {
                display: none;
            }

            &>div {
                .el-image {
                    width: 100% !important;
                    height: 100px !important;
                }

                .time {
                    font-size: 12px;
                }

                .title {
                    font-size: 16px;
                }

                .desc {
                    font-size: 12px;
                    color: rgb(101, 101, 101);
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue